/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu-approve': {
    width: 14,
    height: 11,
    viewBox: '0 0 14 11',
    data: '<path pid="0" d="M13.25.969h-1.092a.498.498 0 00-.392.19L5.323 9.32 2.234 5.406a.5.5 0 00-.392-.19H.75a.125.125 0 00-.098.201l4.28 5.422c.2.253.584.253.785 0l7.631-9.67a.124.124 0 00-.098-.2z" _fill="#595959" fill-rule="nonzero"/>'
  }
})
